var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.00001C0 3.55818 0.358172 3.20001 0.8 3.20001H15.2C15.6418 3.20001 16 3.55818 16 4.00001C16 4.44184 15.6418 4.80001 15.2 4.80001H0.8C0.358172 4.80001 0 4.44184 0 4.00001Z",
    fill: "#FD6B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39998 1.6C6.1878 1.6 5.98432 1.68429 5.83429 1.83431C5.68426 1.98434 5.59998 2.18783 5.59998 2.4V3.2H10.4V2.4C10.4 2.18783 10.3157 1.98434 10.1657 1.83431C10.0156 1.68429 9.81215 1.6 9.59998 1.6H6.39998ZM12 3.2V2.4C12 1.76348 11.7471 1.15303 11.297 0.702944C10.8469 0.252856 10.2365 0 9.59998 0H6.39998C5.76346 0 5.15301 0.252856 4.70292 0.702944C4.25283 1.15303 3.99998 1.76348 3.99998 2.4V3.2H2.39998C1.95815 3.2 1.59998 3.55817 1.59998 4V15.2C1.59998 15.8365 1.85283 16.447 2.30292 16.8971C2.75301 17.3471 3.36346 17.6 3.99998 17.6H12C12.6365 17.6 13.2469 17.3471 13.697 16.8971C14.1471 16.447 14.4 15.8365 14.4 15.2V4C14.4 3.55817 14.0418 3.2 13.6 3.2H12ZM3.19998 4.8V15.2C3.19998 15.4122 3.28426 15.6157 3.43429 15.7657C3.58432 15.9157 3.7878 16 3.99998 16H12C12.2121 16 12.4156 15.9157 12.5657 15.7657C12.7157 15.6157 12.8 15.4122 12.8 15.2V4.8H3.19998Z",
    fill: "#FD6B62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39998 7.20001C6.8418 7.20001 7.19998 7.55818 7.19998 8.00001V12.8C7.19998 13.2418 6.8418 13.6 6.39998 13.6C5.95815 13.6 5.59998 13.2418 5.59998 12.8V8.00001C5.59998 7.55818 5.95815 7.20001 6.39998 7.20001Z",
    fill: "#FD6B62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60005 7.20001C10.0419 7.20001 10.4 7.55818 10.4 8.00001V12.8C10.4 13.2418 10.0419 13.6 9.60005 13.6C9.15822 13.6 8.80005 13.2418 8.80005 12.8V8.00001C8.80005 7.55818 9.15822 7.20001 9.60005 7.20001Z",
    fill: "#FD6B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.711eef337e40f161fb76d6574a16ce2b.svg";
export { ForwardRef as ReactComponent };